import * as React from "react";
import { useState } from "react";

import "./style.scss";

interface ITooltipProps {
  text: string;
  children: React.ReactNode;
  className?: string;
  position?: "bottom" | "left" | "right";
}

function Tooltip(props: ITooltipProps) {
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <span className={`tooltip ${props.className ? props.className : ""}`} onPointerEnter={() => setShowTooltip(true)} onPointerLeave={() => setShowTooltip(false)}>
      {showTooltip && props.text && props.text.trim() && <span className={`tooltip text ${props.position ? props.position : ""}`}>{props.text}</span>}
      {props.children}
    </span>
  );
}

export default Tooltip;



// WEBPACK FOOTER //
// ./src/components/common/Tooltip/Tooltip.tsx